/* tslint:disable */
/* eslint-disable */
import { AusschreibungDisplayModel as AceXFoundPortalCoreCaqModelsAusschreibungDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/ausschreibung-display-model';
import { SchwerpunktDisplayModel as AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/schwerpunkt-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { AusschreibungDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAusschreibungDisplayModelFormGroup } from '@/api/model-index';
import { SchwerpunktDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModelFormGroup } from '@/api/model-index';

export interface IFoerderprogrammDisplayModel {
  abbreviation?: null | string;
  ausschreibungen?: null | Array<AceXFoundPortalCoreCaqModelsAusschreibungDisplayModel>;
  description?: null | string;
  id?: null | string;
  schwerpunkte?: null | Array<AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModel>;
  title?: null | string;
}
export class FoerderprogrammDisplayModel extends BaseModel implements IFoerderprogrammDisplayModel {
  abbreviation?: null | string;
  ausschreibungen?: null | Array<AceXFoundPortalCoreCaqModelsAusschreibungDisplayModel>;
  description?: null | string;
  id?: null | string;
  schwerpunkte?: null | Array<AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModel>;
  title?: null | string;
}
class BaseFoerderprogrammDisplayModelFormGroup extends FormGroup {
  private static _instance: FoerderprogrammDisplayModelFormGroup;
  
  public static get Instance(): FoerderprogrammDisplayModelFormGroup {
    this._instance = new FoerderprogrammDisplayModelFormGroup({
      abbreviation: new FormControl(null),
      ausschreibungen: new FormArray([]),
      description: new FormControl(null),
      id: new FormControl(null),
      schwerpunkte: new FormArray([]),
      title: new FormControl(null),
    });

    return this._instance;
  }
}


export class FoerderprogrammDisplayModelFormGroup extends BaseFoerderprogrammDisplayModelFormGroup {
  public get Abbreviation(): FormControl {
    return this.controls["abbreviation"] as FormControl;
  }
  public get Ausschreibungen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsAusschreibungDisplayModelFormGroup> {
    return this.controls["ausschreibungen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsAusschreibungDisplayModelFormGroup>;
  }
  public get Description(): FormControl {
    return this.controls["description"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Schwerpunkte(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModelFormGroup> {
    return this.controls["schwerpunkte"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModelFormGroup>;
  }
  public get Title(): FormControl {
    return this.controls["title"] as FormControl;
  }
  

}

export module FoerderprogrammDisplayModelForm
  {
    export class FormFields
    {
      static _abbreviation: string = "abbreviation";
      static _ausschreibungen: string = "ausschreibungen";
      static _description: string = "description";
      static _id: string = "id";
      static _schwerpunkte: string = "schwerpunkte";
      static _title: string = "title";
    }
  }

